export default (url, utmContent, utmSource = 'app-planfred') => {
  const urlWithUtmParams = new URL(url)

  urlWithUtmParams.searchParams.set('utm_source', utmSource)
  urlWithUtmParams.searchParams.set('utm_medium', 'app')
  urlWithUtmParams.searchParams.set('utm_content', utmContent)

  return urlWithUtmParams.toString()
}
